import { DayjsProperty } from '@/lib/jackson'
import { Dayjs } from 'dayjs'
import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'

/** Criticality level computed by the backend from (resource_type, action). */
export type AuditLevel = 'HIGH' | 'MEDIUM' | 'LOW'

export type AuditActorType = 'TENANT_USER' | 'MASTER_USER' | 'M2M_CLIENT' | 'SYSTEM' | 'ANONYMOUS'

/** One audit event as returned by `GET /audit-logs` (Accuser wire, snake_case). */
@Serializable()
export class AuditEvent extends Fromable {
  @JsonProperty('id')
  id!: string | number

  @JsonProperty('level')
  level!: AuditLevel

  @JsonProperty('action')
  action!: string

  @JsonProperty('resource_type')
  resourceType!: string

  @JsonProperty('resource_id')
  resourceId?: string | number | null

  @JsonProperty('resource_name')
  resourceName?: string | null

  @JsonProperty('actor_type')
  actorType?: AuditActorType | null

  @JsonProperty('actor_id')
  actorId?: string | null

  @JsonProperty('actor_name')
  actorName?: string | null

  @JsonProperty('actor_role')
  actorRole?: string | null

  @JsonProperty('subject_type')
  subjectType?: string | null

  @JsonProperty('subject_id')
  subjectId?: string | number | null

  @JsonProperty('subject_name')
  subjectName?: string | null

  @JsonProperty('branch_id')
  branchId?: number | string | null

  @JsonProperty('branch_name')
  branchName?: string | null

  @JsonProperty('parent_resource_type')
  parentResourceType?: string | null

  @JsonProperty('parent_resource_id')
  parentResourceId?: string | number | null

  @JsonProperty('before')
  before?: Record<string, unknown> | null

  @JsonProperty('after')
  after?: Record<string, unknown> | null

  @JsonProperty('changed_fields')
  changedFields?: string[] | null

  @JsonProperty('outcome')
  outcome?: string | null

  @JsonProperty('reason_code')
  reasonCode?: string | null

  @JsonProperty('source_module')
  sourceModule?: string | null

  @DayjsProperty({ path: 'occurred_at' })
  occurredAt?: Dayjs | null

  @JsonProperty('metadata')
  metadata?: Record<string, unknown> | null
}

export interface AuditEventFilter {
  /** Inclusive ISO range bounds. */
  from?: string
  to?: string
  level?: AuditLevel
  /** Selected event types as `RESOURCE:ACTION` pairs. */
  eventTypes?: string[]
  actorId?: string
  actorType?: AuditActorType
  branchId?: number
  limit?: number
}

export interface AuditEventListResponse {
  data: AuditEvent[]
  /** Window overflowed — the UI should suggest narrowing the date range. */
  truncated: boolean
}
